"use strict";

const HardAssetInventoryDrainageArea = function () {
  const stringKey = "hard-asset-drainage-area";
  const headerInformation = "Drainage Area";
  let $page;

  var getStringKey = function () {
    return stringKey;
  };

  var getHeaderInformation = function () {
    return headerInformation;
  };

  var render = async function () {
    renderPageHtml();
    Form.initializeAndLoadListeners(
      $page,
      HardAssetInventoryModalController.getInventoryFormKey(),
      { isMultiPart: true },
    );
    loadListeners();
    showDrainageAreaModalMap();
  };

  var loadListeners = function () {
    $page.on("2N:FormInput", `[name="ttFlowsTo"]`, onPairedBmpChange);
  };

  var removeListeners = function () {
    $page.off("2N:FormInput", `[name="ttFlowsTo"]`, onPairedBmpChange);
  };

  var onPairedBmpChange = async function (e, pairedBmpId) {
    const pairedBmp =
      HardAssetInventoryModalController.getInventoryForRender().centralizedBmps.find(
        (centralizedBmp) => centralizedBmp.idbmp === parseInt(pairedBmpId),
      );
    const pairedDrainageGeom = pairedBmp.dissolvedDrainage.geom;

    if (!pairedDrainageGeom) {
      return;
    }

    await DrawController.setDrawnDrainageGeom(JSON.parse(pairedDrainageGeom));
    await AreaSelectionMap.setActiveMethodLayer("drawing-tools");
  };

  var renderPageHtml = function () {
    const data = HardAssetInventoryModalController.getInventoryForRender();
    const html = nunjucks.render("modals/hardAssetInventory/hardAssetInventoryDrainageArea.njk", {
      fields: HardAssetInventoryFields.getDrainageFields(
        HardAssetInventoryModalController.getAssetType(),
        data,
      ),
      treatmentTrain: HardAssetInventoryFields.getTreatmentTrainRow(data),
    });
    HardAssetInventoryModalController.renderPageContent(html);
    $page = $(".modal-dynamic-content");
  };

  var showDrainageAreaModalMap = function () {
    AreaSelectionMap.resetAreaSelectionMapHandlers();
    ModalMap.disableMarkerRelocation();
    ModalMap.configureModalMapHandlers({ newExistingMarkerHandler: loadExistingMarker });
    ModalMap.refreshMarkerLayer();
    AreaSelectionMap.configureAreaSelectionMapHandlers(
      DrainageTable.getDrainageTableConfigurations(
        HardAssetInventoryModalController.getLatestData,
        HardAssetInventoryModalController.setFormDataField,
      ),
    );

    AreaSelectionMap.showAreaSelectionMap(true);
    AreaSelectionMap.setActiveMethodLayer(
      HardAssetInventoryModalController.getLatestData("drawMethod") ?? "drawing-tools",
    );
    ModalMap.zoomToMarker(true);
    DrawController.zoomToDrainage();
    showCentralizedBmps();
  };

  // The sibling centralized BMPs and their drainage show what this asset can be paired with
  var showCentralizedBmps = function () {
    const bmpType = HardAssetInventoryModalController.getInventoryForRender().bmpType;

    if (BmpFcsFunctions.isCentralizedBMPType(bmpType)) {
      CentralizedBmpLayer.show(HardAssetInventoryModalController.getLatestData, () =>
        HardAssetInventoryModalController.getExistingData("id"),
      );
    } else {
      CentralizedBmpLayer.hide();
    }
  };

  var loadExistingMarker = function () {
    const latLng = HardAssetInventorySetLocation.parseLatLng(
      HardAssetInventoryModalController.getInventoryForRender(),
    );
    if (latLng) {
      ModalMap.createNewSingleMarker(latLng);
    }
  };

  var validate = function () {
    if (imperviousAreaExceedsTotalArea()) {
      MessageModal.showReturnWarningModal(
        "You have entered an Impervious Drainage Area that is greater than the selected total drainage area. Return to Drainage Area to resolve this error.",
      );
      return false;
    }
    return true;
  };

  var imperviousAreaExceedsTotalArea = function () {
    const totalTreated = parseFloat($(".total-treated").text());
    const imperviousArea = HardAssetInventoryModalController.getLatestData("imperviousArea");

    return imperviousArea > totalTreated;
  };

  var cleanUp = function () {
    removeListeners();
    AreaSelectionMap.hideAreaSelectionMap();
    CentralizedBmpLayer.hide();
    $page.empty();
    return true;
  };

  var resetState = function () {
    AreaSelectionMap.resetDrawController();
  };

  return {
    getStringKey,
    getHeaderInformation,
    render,
    cleanUp,
    validate,
    resetState,
  };
};

module.exports = HardAssetInventoryDrainageArea();

const AreaSelectionMap = require("../../mapFunctions/areaSelectionMap");
const BmpFcsFunctions = require("../../bmpfcs/bmpFcsFunctions");
const CentralizedBmpLayer = require("../../bmpfcs/centralizedBmpLayer");
const DrainageTable = require("../../mapFunctions/drainageTable");
const DrawController = require("../../mapFunctions/drawController");
const Form = require("../../general/form");
const HardAssetInventoryFields = require("./hardAssetInventoryFields");
const HardAssetInventoryModalController = require("../hardAssetInventoryModalController");
const HardAssetInventorySetLocation = require("./hardAssetInventorySetLocation");
const MessageModal = require("../../modals/messageModal");
const ModalMap = require("../../mapFunctions/modalMap");
